export { useHorizontalNavMenuHeaderGroup as default };
import * as vue_composition_api from '@vue/composition-api';
import core_layouts_utils from '@core/layouts/utils';


function useHorizontalNavMenuHeaderGroup(item) {
  // ------------------------------------------------
  // isOpen
  // ------------------------------------------------
  const isOpen = vue_composition_api.ref(false);
  const updateGroupOpen = val => {
    isOpen.value = val;
  };

  // ------------------------------------------------
  // isActive
  // ------------------------------------------------
  const isActive = vue_composition_api.ref(false);
  const updateIsActive = () => {
    isActive.value = core_layouts_utils.isNavGroupActive(item.children);
  };
  return {
    isOpen,
    isActive,
    updateGroupOpen,
    updateIsActive
  };
}

